module.exports = __webpack_public_path__ + "static/media/welding_hover.9159e418.svg";